/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const ifExternalUrl = (e, url) => {
    if (url.includes('https://' || url.includes('http://')) && typeof window !== 'undefined') {
        e.preventDefault();
        window.open(url);
    }
};

export const elementWidth = (data) => {
    // Base element widths on number of rows.
    // E.g. 10 items across 1 row = 10% width (+/-) each
    //      10 items across 2 rows = 20% width (+/-) each
    // if 1 row and two elements, create narrower gap between both thatn ususal.
    const elementCount = data?.reference?.length || 0;
    const rowCount = data?.row_count || 1;
    let widthValue = 0;

    if (rowCount > 1) { // more than one row, distribute elements to rows by making widths relative to row count
        widthValue = `${98 / (elementCount / rowCount)}%`;
    }

    if (rowCount === 1) { // only one row, make widths even
        widthValue = `${98 / elementCount}%`;
    }

    if (elementCount === 2) { // only two elements, make gap small
        widthValue = `${99.5 / elementCount}%`;
    }

    return { width: widthValue };
};
